import { render, staticRenderFns } from "./BeiAnCom.vue?vue&type=template&id=60ceea41&scoped=true"
import script from "./BeiAnCom.vue?vue&type=script&lang=js"
export * from "./BeiAnCom.vue?vue&type=script&lang=js"
import style0 from "./BeiAnCom.vue?vue&type=style&index=0&id=60ceea41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ceea41",
  null
  
)

export default component.exports